module.exports = __webpack_public_path__ + "img/gs.ec61a349.svg";